import { render, staticRenderFns } from "./DevOnly.vue?vue&type=template&id=e11f45c2&"
import script from "./DevOnly.vue?vue&type=script&lang=js&"
export * from "./DevOnly.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports